import { toast } from 'react-toastify';
import { updateStore } from '@/api/store';
import { create } from 'zustand';

interface CustomizationValues {
   store: string;
   storename: string;
   description?: string;
   location: string;
   logo?: string;
   storeDomain?: string;
   settings: {
      btnColor: string;
      btnLabel: string;
      btnEmbed: string;
      designTheme: string;
      colorTheme: string;
      imgs: string[];
      slidesEnabled: boolean;
      slidesHeight: number;
   };
}

interface State {
   showSave: boolean;
   valuesSave: CustomizationValues | null;
   typeSave: string | null;
   isLoading: boolean;
   handleShowSave: (show: boolean) => void;
   handleCloseSave: () => void;
   handleValues: (
      values: CustomizationValues | null,
      type: string | null
   ) => void;
   handleSave: () => void;
   successSave: boolean;
   handleDiscard: () => void;
   handleSuccessSave: (value: boolean) => void;
}

const useSaveChangesStore = create<State>((set, get) => ({
   showSave: false,
   valuesSave: null,
   typeSave: null,
   isLoading: false,
   successSave: false,
   handleShowSave: (show) => set({ showSave: show }),
   handleCloseSave: () => set({ showSave: false }),
   handleValues: (values, type) => set({ valuesSave: values, typeSave: type }),
   handleSave: async () => {
      if (get().isLoading) return;
      set({ isLoading: true });
      const { valuesSave, typeSave } = get();
      if (typeSave === 'customization' && valuesSave) {
         updateStore({
            storeId: valuesSave.store,
            storename: valuesSave.storename,
            description: valuesSave.description,
            location: valuesSave.location,
            logo: valuesSave.logo,
            settings: {
               btnColor: valuesSave.settings.btnColor,
               btnLabel: valuesSave.settings.btnLabel,
               btnEmbed: valuesSave.settings.btnEmbed,
               designTheme: valuesSave.settings.designTheme,
               colorTheme: valuesSave.settings.colorTheme || '#B3D946',
               imgs: valuesSave.settings.imgs || [],
               slidesEnabled: valuesSave.settings.slidesEnabled,
               slidesHeight: valuesSave.settings.slidesHeight,
            },
         })
            .then(async (res) => {
               toast.success(res.data.msg, {
                  position: 'bottom-center',
                  autoClose: 2500,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
               });

               await new Promise((resolve) => setTimeout(resolve, 300));
               set({ showSave: false, successSave: true });
            })
            .catch((err) => {
               console.log(`Error`, err);
               toast.error((err as Error)?.message || 'Server Error', {
                  position: 'bottom-center',
                  autoClose: 2500,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
               });
            })
            .finally(() => {
               set({ isLoading: false });
               set({ successSave: false });
            });
      }
   },
   handleDiscard: () => {
      set({ showSave: false });
      set({ successSave: false });
   },
   handleSuccessSave: (value: boolean) => {
      set({ successSave: value });
   },
}));

export default useSaveChangesStore;
